import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { NgbDropdownModule, NgbPaginationModule, NgbPopoverModule, NgbRatingModule, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap'
import { MatMenuModule } from '@angular/material/menu'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { MomentModule } from 'ngx-moment'
import { NgPipesModule } from 'ngx-pipes'
import { NgxFlowModule } from '@flowjs/ngx-flow'
import { PickerModule } from '@ctrl/ngx-emoji-mart'

import { UtilCommonModule } from 'common/util/module'
import { UtilReleaseNotesModule } from 'common/util.releaseNotes/module'
import { EntityListModule } from 'common/entityList'
import { LocaleModule } from 'common/locale/module'
import { MediaPermissionsModule } from 'media.permissions'
import { MediaCustomFieldsModule } from 'media.customFields'
import { MediaTagsModule } from 'media.tags'

import { SavedSearchItemComponent } from './components/savedSearchItem.component'
import { VideoThumbnailComponent } from './components/videoThumbnail.component'
import { SeekableThumbnailComponent } from './components/seekableThumbnail.component'
import { AssetIconComponent } from './components/assetIcon.component'
import { MediaItemLabelsComponent } from './components/mediaItemLabels.component'
import { MediaBreadcrumbsComponent } from './components/mediaBreadcrumbs.component'
import { AudioThumbnailComponent } from './components/audioThumbnail.component'
import { AssetThumbnailComponent } from './components/assetThumbnail.component'
import { DirectoryIconComponent } from './components/directoryIcon.component'
import { MediaDirectoryItemComponent } from './components/mediaDirectoryItem.component'
import { MediaBundleItemComponent } from './components/mediaBundleItem.component'
import { MediaFileListComponent } from './components/mediaFileList.component'
import { MediaInfoPopoverComponent } from './components/mediaInfoPopover.component'
import { MediaFileListTagsDropdownComponent } from './components/mediaFileListTagsDropdown.component'
import { MediaFileListToolbarComponent } from './components/mediaFileListToolbar.component'
import { MediaClipboardComponent } from './components/mediaClipboard.component'
import { RegenerateProxiesModalComponent } from './components/regenerateProxiesModal.component'
import { MediaTagsManagerModalComponent } from './components/mediaTagsManagerModal.component'
import { CustomFieldsEditorModalComponent } from './components/customFieldsEditorModal.component'
import { MediaCreateFromTemplateCreateModalComponent } from './components/mediaCreateFromTemplateCreateModal.component'
import { MediaCreateFromTemplateSelectModalComponent } from './components/mediaCreateFromTemplateSelectModal.component'
import { SeekBarComponent } from './components/seekBar.component'
import { SceneNavigatorComponent } from './components/sceneNavigator.component'
import { TimestampDisplayComponent } from './components/timestampDisplay.component'
import { TimecodeInputComponent } from './components/timecodeInput.component'
import { RegenerateProxiesOptionsComponent } from './components/regenerateProxiesOptions.component'
import { AssetTagsEditorComponent } from './components/assetTagsEditor.component'
import { MediaHeaderBlockComponent } from './components/mediaHeaderBlock.component'
import { SubclipsClipboardComponent } from './components/subclipsClipboard.component'
import { SubtitlesClipboardComponent } from './components/subtitlesClipboard.component'
import { CreateEditorProjectModalComponent } from './components/createEditorProjectModal.component'
import { CommentInputFieldComponent } from './components/commentInputField.component'
import { PdfEmbedComponent } from './components/pdfEmbed.component'
import { MediaOperationButtonComponent } from './components/mediaOperationButton.component'

import { MediaBrowseView } from './views/mediaBrowseView.component'
import { MediaBrowseLocatorView } from './views/mediaBrowseLocatorView.component'

export { ClientSideURLService } from './services/clientSideURL.service'
export { MediaClipboardService } from './services/mediaClipboard.service'
export { MediaPermissionsService } from './services/mediaPermissions.service'
export { MediaScannerService } from './services/mediaScanner.service'

@NgModule({
  imports: [
    CommonModule,
    UtilCommonModule,
    UtilReleaseNotesModule,
    LocaleModule.forChild(),
    RouterModule.forChild([]),
    FormsModule,
    ReactiveFormsModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbPopoverModule,
    NgbPaginationModule,
    NgbRatingModule,
    NgbTypeaheadModule,
    NgxFlowModule,
    MatMenuModule,
    DragDropModule,
    MomentModule,
    PickerModule,
    EntityListModule,
    NgPipesModule,
    MediaPermissionsModule,
    MediaCustomFieldsModule,
    MediaTagsModule,
  ],
  declarations: [
    AssetIconComponent,
    AssetTagsEditorComponent,
    AssetThumbnailComponent,
    CommentInputFieldComponent,
    SceneNavigatorComponent,
    AudioThumbnailComponent,
    CustomFieldsEditorModalComponent,
    CreateEditorProjectModalComponent,
    DirectoryIconComponent,
    MediaBundleItemComponent,
    MediaCreateFromTemplateCreateModalComponent,
    MediaCreateFromTemplateSelectModalComponent,
    MediaClipboardComponent,
    MediaDirectoryItemComponent,
    MediaFileListComponent,
    MediaFileListToolbarComponent,
    MediaFileListTagsDropdownComponent,
    MediaHeaderBlockComponent,
    MediaInfoPopoverComponent,
    MediaItemLabelsComponent,
    MediaBreadcrumbsComponent,
    MediaOperationButtonComponent,
    MediaTagsManagerModalComponent,
    PdfEmbedComponent,
    RegenerateProxiesModalComponent,
    RegenerateProxiesOptionsComponent,
    SavedSearchItemComponent,
    SeekableThumbnailComponent,
    SeekBarComponent,
    SceneNavigatorComponent,
    SubclipsClipboardComponent,
    SubtitlesClipboardComponent,
    VideoThumbnailComponent,
    TimestampDisplayComponent,
    TimecodeInputComponent,
    MediaBrowseView,
    MediaBrowseLocatorView,
  ],
  exports: [
    TimecodeInputComponent,
  ],
})
export class MediaModule {
  static ROUTES = [
    ...MediaBrowseLocatorView.ROUTES, // TODO lift into Router.forChild once all /media URLs are migrated
    ...MediaBrowseView.ROUTES, // TODO lift into Router.forChild once all /media URLs are migrated
  ]
}

export default MediaModule
